module.exports = __webpack_public_path__ + "img/ic_company_register.6d0caadb.svg";